import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolonavalabustourpackage() {



  const cardData =
  {
    keyword: 'Pune to Lonavala Bus Tour Package ',
    heading: 'Sanavi Travels: Pune to Lonavala Bus Tour Package',
    headingDescription: 'Sanavi Travels offers reliable Pune to Lonavala Bus Tour Package, providing safe, comfortable, and well-organized travel solutions for families, corporate outings, school and college groups, picnic tours, and weekend travelers planning a refreshing getaway from Pune to Lonavala. Our fleet of AC and Non-AC buses ranging from 20, 25, 30, 32, 35, 40, 45 to 50 seaters, along with tempo travellers on request, is well-maintained and designed for short-distance comfort with spacious seating and ample luggage space. With experienced hill-route drivers, flexible one-day and overnight tour packages, transparent pricing, and punctual service, Sanavi Travels ensures a smooth and enjoyable journey. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Lonavala attractions such as Lion’s Point, Bhushi Dam, Rajmachi Point, Karla Caves, Bhaja Caves, Tungarli Lake, and Wax Museum. Choose Sanavi Travels for a trusted Pune to Lonavala bus tour package, delivering comfort, safety, and a memorable hill-station travel experience.',

    top: 'Top Places to Visit in Lonavala with Sanavi Travels',


"topPlaces": [
  {
    "title": "Lion’s Point",
    "description": "Lion’s Point is one of the most popular viewpoints in Lonavala, offering breathtaking panoramic views of the Sahyadri ranges and deep valleys. Especially stunning during the monsoon, the misty hills and waterfalls create a magical atmosphere. It is a favorite stop for tourists, photographers, and couples. Lion’s Point is perfect for enjoying sunsets, cool breezes, and scenic mountain beauty."
  },
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is Lonavala’s most famous attraction, known for its cascading steps and monsoon fun. Visitors enjoy sitting under flowing water and splashing around with friends and family. Surrounded by hills and greenery, it becomes lively during the rainy season. Bhushi Dam is ideal for adventure, relaxation, and memorable group outings."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic fort located between Lonavala and Karjat, popular among trekkers and history enthusiasts. The fort offers spectacular views of valleys, waterfalls, and lush landscapes. Trekking routes pass through dense forests and scenic trails. Rajmachi Fort beautifully blends Maratha history with thrilling adventure."
  },
  {
    "title": "Karla Caves",
    "description": "Karla Caves are ancient Buddhist rock-cut caves dating back to the 2nd century BCE. The grand Chaitya hall with massive pillars and intricate carvings reflects excellent ancient craftsmanship. Located on a hilltop, the caves offer both historical and spiritual significance. Karla Caves are a must-visit heritage site in Lonavala."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort is one of the strongest forts built during the Maratha Empire and is easily accessible from Lonavala. Known for its iconic Vinchu Kata (Scorpion’s Tail), the fort offers panoramic views of the surrounding hills. It is a popular trekking destination, especially during monsoon. Lohagad Fort stands as a symbol of Maratha architectural brilliance."
  },
  {
    "title": "Tiger’s Leap",
    "description": "Tiger’s Leap is a dramatic cliff-top viewpoint that gives the illusion of a leaping tiger. It offers a deep valley view with echo points that fascinate visitors. During monsoon, waterfalls flow down the cliffs creating a spectacular scene. Tiger’s Leap is perfect for nature lovers and photography enthusiasts."
  },
  {
    "title": "Wax Museum",
    "description": "The Wax Museum in Lonavala features lifelike wax statues of famous personalities, historical figures, and celebrities. It is an entertaining spot for families and children. The museum provides great photo opportunities and a fun indoor experience. It adds a unique attraction to Lonavala’s tourist circuit."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake is a serene reservoir near Lonavala, popular for camping, boating, and lakeside picnics. Surrounded by hills and forts, the calm waters reflect stunning sunrise and sunset views. Night camping with bonfires and stargazing is a major attraction. Pawna Lake offers a peaceful escape into nature."
  },
  {
    "title": "Duke’s Nose",
    "description": "Duke’s Nose, also known as Nagphani, is a popular trekking and rock-climbing destination near Lonavala. The cliff resembles the shape of a nose, offering breathtaking views of valleys and dense forests. It is a favorite among adventure enthusiasts. Duke’s Nose is perfect for thrill-seekers and nature explorers."
  },
  {
    "title": "Khandala Ghat",
    "description": "Khandala Ghat is a scenic mountain pass near Lonavala, known for its lush greenery, waterfalls, and winding roads. The area becomes especially beautiful during monsoon. Several viewpoints along the ghat offer mesmerizing vistas. Khandala Ghat is ideal for scenic drives and nature photography."
  }
]
,





"services": [
  {
    "name": "Pune to Lonavala Bus Tour Package",
    "description": "Pune to Lonavala Bus Tour Package offers a well-organized and comfortable travel option for tourists planning a scenic trip to Lonavala. Ideal for families, friends, and groups, this package includes spacious buses, professional drivers, and smooth travel through hill roads. Passengers enjoy safe transportation, planned sightseeing stops, and a relaxed journey, making it perfect for a refreshing getaway from Pune."
  },
  {
    "name": "Lonavala Bus Tour from Pune",
    "description": "Lonavala Bus Tour from Pune provides reliable and comfortable bus services for day trips and short tours. Designed for group and family travel, the service ensures comfortable seating, experienced chauffeurs, and timely departures. Travelers can enjoy the scenic beauty of Lonavala without worrying about driving or navigation."
  },
  {
    "name": "AC Bus Pune to Lonavala",
    "description": "AC Bus Pune to Lonavala offers air-conditioned buses for a cool and comfortable journey, especially suitable for weekend trips and summer travel. With spacious interiors and smooth suspension, these buses ensure a pleasant ride through highways and hill routes while maintaining safety and comfort."
  },
  {
    "name": "Luxury Lonavala Tour Bus",
    "description": "Luxury Lonavala Tour Bus provides premium buses with elegant interiors and enhanced comfort for travelers seeking a superior experience. Ideal for corporate outings, VIP travel, or special family trips, these buses offer a stylish and relaxing journey to Lonavala with professional chauffeur service."
  },
  {
    "name": "Family Lonavala Bus Tour",
    "description": "Family Lonavala Bus Tour is specially designed for families traveling together. With comfortable seating, safe driving practices, and ample space for luggage, this service ensures a smooth and enjoyable journey for all age groups, including children and senior citizens."
  },
  {
    "name": "Group Travel Lonavala Bus",
    "description": "Group Travel Lonavala Bus caters to large groups such as friends, corporate teams, or tour groups. Spacious buses and coordinated travel plans ensure everyone travels together comfortably, making group outings to Lonavala convenient and enjoyable."
  },
  {
    "name": "Affordable Lonavala Bus Package",
    "description": "Affordable Lonavala Bus Package provides budget-friendly travel solutions without compromising on safety or comfort. Ideal for cost-conscious travelers, this service offers well-maintained buses, experienced drivers, and transparent pricing for trips from Pune to Lonavala."
  },
  {
    "name": "Chauffeur Driven Lonavala Bus",
    "description": "Chauffeur Driven Lonavala Bus offers professional and experienced drivers who handle hill routes and traffic efficiently. Passengers can relax and enjoy the journey while ensuring safety, punctuality, and a stress-free travel experience to Lonavala."
  },
  {
    "name": "Best Lonavala Tour Bus Pune",
    "description": "Best Lonavala Tour Bus Pune delivers high-quality bus services known for comfort, reliability, and punctuality. Suitable for families, tourists, and corporate groups, this service focuses on providing a smooth and enjoyable travel experience from Pune to Lonavala."
  },
  {
    "name": "Pune Lonavala Travel Bus",
    "description": "Pune Lonavala Travel Bus provides dependable transportation between Pune and Lonavala for sightseeing and leisure trips. With spacious interiors and skilled drivers, this service ensures a relaxed and safe journey through scenic hill roads."
  },
  {
    "name": "Tourist Bus Hire Lonavala",
    "description": "Tourist Bus Hire Lonavala offers buses specifically for sightseeing and tourism purposes. Ideal for visiting popular attractions, viewpoints, and resorts, this service ensures organized travel with comfort and convenience for tourists."
  },
  {
    "name": "Hill Station Bus Tour Pune",
    "description": "Hill Station Bus Tour Pune is perfect for travelers looking to explore nearby hill stations like Lonavala. Comfortable buses, professional drivers, and scenic routes make this service ideal for nature lovers and weekend travelers."
  },
  {
    "name": "Weekend Trip Bus Lonavala",
    "description": "Weekend Trip Bus Lonavala provides convenient bus services for short weekend getaways. Ideal for families, friends, and office groups, this service ensures timely travel, comfortable seating, and a refreshing travel experience."
  },
  {
    "name": "Holiday Bus Package Lonavala",
    "description": "Holiday Bus Package Lonavala offers planned travel solutions for leisure and holiday trips. Designed for stress-free travel, this service focuses on comfort, sightseeing convenience, and enjoyable journeys for all passengers."
  },
  {
    "name": "Lonavala Trip Bus Service",
    "description": "Lonavala Trip Bus Service provides reliable and comfortable buses for complete Lonavala tours. Suitable for day trips or short stays, this service ensures safety, comfort, and professional support throughout the journey."
  }
],
"tableData": [
  ["Pune to Lonavala Bus Tour Package", "Lonavala Bus Tour from Pune"],
  ["AC Bus Pune to Lonavala", "Luxury Lonavala Tour Bus"],
  ["Family Lonavala Bus Tour", "Group Travel Lonavala Bus"],
  ["Affordable Lonavala Bus Package", "Chauffeur Driven Lonavala Bus"],
  ["Best Lonavala Tour Bus Pune", "Pune Lonavala Travel Bus"],
  ["Tourist Bus Hire Lonavala", "Hill Station Bus Tour Pune"],
  ["Weekend Trip Bus Lonavala", "Holiday Bus Package Lonavala"],
  ["Lonavala Trip Bus Service", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Lonavala Bus Tour Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and well-organized Pune to Lonavala bus tour packages, ideal for family outings, group tours, corporate trips, and weekend getaways."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-maintained buses ensuring a smooth and enjoyable journey from Pune to Lonavala."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Hill Routes",
    "WhyChoosedescription": "Our professional drivers are experienced with Pune–Lonavala roads and ghat sections, ensuring safe and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Pune to Lonavala bus tour packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, itinerary planning, and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Tour Packages",
    "WhyChoosedescription": "Choose from one-day trips, weekend tours, or customized Pune to Lonavala bus tour packages as per your group’s requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual departures and dependable service, making Sanavi Travels a trusted choice for Lonavala bus tours from Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Pune to Lonavala bus tour packages?',
    answer: 'Yes, Sanavi Travels provides comfortable and well-organized bus tour packages from Pune to Lonavala.'
  },
  {
    question: 'How can I book a Pune to Lonavala bus tour package with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are used for the Pune to Lonavala tour?',
    answer: 'We provide air-conditioned and well-maintained buses suitable for short-distance and group travel.'
  },
  {
    question: 'Are drivers included in the bus tour package?',
    answer: 'Yes, all tour packages include experienced and professional drivers familiar with the Pune–Lonavala route.'
  },
  {
    question: 'Is the service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel assistance.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Pune to Lonavala bus tour package?',
    answer: 'Absolutely. Sanavi Travels offers customized tour packages according to your travel needs.'
  },
  {
    question: 'What payment options are available for the bus tour package?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the tour?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Lonavala journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Kulkarni',
    feedback: 'Booked a Pune to Lonavala bus tour with Sanavi Travels. Comfortable bus, punctual service, and a very smooth journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Deshpande',
    feedback: 'Great experience! Clean bus, professional driver, and excellent coordination. Perfect for a weekend Lonavala trip.',
    rating: 5
  }
];
































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Bus Tour Package - Sanavi Travels",
  "description": "Pune to Lonavala bus tour packages by Sanavi Travels for family trips, group travel, hill station visits, weekend trips, and holiday tours. Choose AC and luxury buses for safe, comfortable, and affordable travel from Pune to Lonavala.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1650"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Pune to Lonavala Bus Tour Package Starting from ₹45 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to Lonavala bus tour packages with Sanavi Travels. AC and luxury buses for family trips, group travel, hill station visits, weekend trips, and holiday tours at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolonavalabustourpackage;